// An Icon the fits "Migration"
import SystemUpdateAlt from "@mui/icons-material/SystemUpdateAlt";

// Central icon for courses. Replace here to update everywhere.
export default SystemUpdateAlt;
